import { usePath } from "../libs/path/PathProvider";
import FoodUtils from "../utils/FoodUtils";
import IconButton from "../gui/Button/IconButton";
import AddIcon from "../gui/Icons/AddIcon";
import { useFoods } from "../utils/FoodProvider";

export default function Header(props:{onAdd:Function}){
    const {path} = usePath()
    const {ready} = useFoods()
    return <header>
        <div className="content flex middle between gap-24">
            <div className="logo"/>
            <h1 className="flex1 center">{FoodUtils.getTitle(path)}</h1>
            <IconButton size="medium" onClick={e => props.onAdd()} disabled={!ready}><AddIcon/></IconButton>
        </div>
    </header>
}